import { PropertyType } from '../../../common';

export const mapEntityToApi = (data: PropertyType): PropertyType => ({
	token: data.token,
	email: data.email,
	password: data.password,
	password_confirmation: data.repeatPassword,
	two_step_code: data.two_step_code,
});
